import React, { Component } from 'react'
import DefaultLayout from '../../../DefaultLayout'

import './styles.scss'

import { Col, Container, Row } from '../../../../Shared/Grid'
import Box from '../../../../Shared/Box'
import { withTranslation } from 'react-i18next'
import Loader from '../../../../Shared/Loader'
import { withRouter } from 'react-router-dom'
import { confirmCancellation, getCancellation } from '../../../../../api'
import Button from '../../../../Shared/Form/Button'
import Alert from '../../../../Shared/Alert'
import dayjs from 'dayjs'

class CancellationConfirmPage extends Component {

  constructor (props) {
    super(props)
    this.state = this.getDefaultState()
    this.abortController = null
  }

  componentDidMount () {
    const token = this.props.match.params.token
    this.setState({ token }, () => {
      this.getCancellationToken(token)
    })
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (this.state.token !== this.props.match.params.token) {
      this.setState(
        {
          ...this.getDefaultState(),
          token: this.props.match.params.token
        }, () => {
          this.getCancellationToken(this.state.token)
        })
    }
  }

  componentWillUnmount () {
    this.abortAbortController()
  }

  abortAbortController () {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
  }

  getDefaultState () {
    return {
      loading: false,
      error: null,
      errorConfirm: null,
      cancellation: null,
      token: null,
      confirmed: null
    }
  }

  getCancellationToken (token) {
    this.abortAbortController()
    this.abortController = new AbortController()
    this.setState({ loading: true, error: null, cancellation: null }, () => {
      getCancellation(token, this.abortController).fetchPromise.then(async (response) => {
        if (response.ok) {
          this.setState({ loading: false, cancellation: await response.json() })
        } else if (response.status === 404) {
          this.setState({
            loading: false, error: 'Cancellation Token not found or expired.'
          })
        } else {
          this.setState({ loading: false, error: 'Error' })
        }
      }).catch(() => {
        this.setState({ loading: false, error: 'Error' })
      })
    })
  }

  confirmCancellation = () => {
    this.abortAbortController()
    this.abortController = new AbortController()
    this.setState({ loading: true, errorConfirm: null }, () => {
      confirmCancellation(this.state.token, this.abortController).fetchPromise.then(() => {
        this.setState({ confirmed: true, loading: false })
      }).catch(() => {
        this.setState({ loading: false, errorConfirm: 'Error' })
      })
    })
  }

  createSubscriptionItemRow (item) {
    return <tr key={'sub-item-' + item.id}>
      <td data-title={'GIATA-ID'}>{item.id}</td>
      <td data-title={this.props.i18n.t('HOTEL')}>{item.hotelName}</td>
    </tr>
  }

  render () {
    const { t } = this.props
    return (
      <DefaultLayout>
        <div className="cancellationConfirmPage">
          <Box>
            <Container className="cancellationConfirmPageContainer" fluid gutterWidth={5}>
              {this.state.loading && <Loader size={32}/>}
              <Row>
                <Col xs={12}>
                  <h3>{t('CONFIRM_CANCELLATION')}</h3>
                </Col>
              </Row>
              {this.state.error && <Row>
                <Col xs={12}>
                  <Alert type={'danger'}>{this.state.error}</Alert>
                </Col>
              </Row>
              }
              {!this.state.error && this.state.cancellation &&
              <React.Fragment>
                <Row>
                  <Col xs={12}><h4>Id - {this.state.cancellation.subscription.id}</h4></Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <div className="flex-table" style={{ flex: 1 }}>
                      <div style={{ position: 'relative' }} className="table-responsive-vertical">
                        <table className="table table-hover table-mc-light-blue Gradient">
                          <thead>
                          <tr>
                            <td>GIATA-ID</td>
                            <td>{t('HOTEL')}</td>
                          </tr>
                          </thead>
                          <tbody>
                          {this.state.cancellation.subscriptionItems.map(item => this.createSubscriptionItemRow(item))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
                {!this.state.confirmed ?
                  <Row>
                    <Col xs={12}>
                      <Alert type={'info'}>{t('CANCELLATION_INFO_EXPIRES_AT_DATE', {
                        'date':
                          this.state.cancellation.subscription.expiresAt ?
                            dayjs(this.state.cancellation.subscription.expiresAt).locale(this.props.i18n.language).format('LL')
                            : '-'
                      })}</Alert>
                      <Button
                        type={'submit'}
                        disabled={this.state.confirmed}
                        align="right"
                        onClick={this.confirmCancellation}>{t('CONFIRM')}</Button>
                    </Col>
                  </Row> :
                  <Row>
                    <Col xs={12}>
                      <Alert type={'success'}>{t('CANCELLATION_SUCCESSFUL')}</Alert>
                    </Col>
                  </Row>
                }
                {
                  this.state.errorConfirm && <Row>
                    <Col xs={12}>
                      <Alert type={'danger'}>Error</Alert>
                    </Col>
                  </Row>
                }
              </React.Fragment>
              }
            </Container>
          </Box>
        </div>
      </DefaultLayout>
    )
  }
}

export default withRouter(withTranslation()(CancellationConfirmPage))
